import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import bgvid from '../assets/vid/particle.mp4';
import Grow from '@mui/material/Grow';
import Fade from '@mui/material/Fade';
import {useEffect, useState} from 'react';
import '../App.css';

export default function Home(){
    
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [tam, setTam] = useState(null);

    useEffect(() => {
        function handleWindowResize() {
          setWindowSize(getWindowSize());
        }
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);

      useEffect(() => {

        if(windowSize.innerWidth >=700){
            setTam(6)
        }
        else{
            setTam(12)
        }
      });

        //navegacion
        const navigate = useNavigate();
        const redirect = () =>{
        navigate("/projects");
        }

    return(
        <Box alignItems="center"
        justifyContent="center">

            <Grid container spacing={1}
                alignItems="center"
                justifyContent="center"
                sx={{position: 'absolute', zIndex: 2}}
                >

                <Grid item xs={tam} alignItems="center"
                    justifyContent="center">
                </Grid>

                <Grow in={true} timeout={2000}>
                <Grid item xs={tam} alignItems="center"
                    justifyContent="center" mt={8}>

                    <Grid item xs={5} ml={20} alignItems="left"
                    justifyContent="left">

                        <Typography variant="h2"
                        sx={{  fontSize:150,
                            background: 'linear-gradient(135deg, #d6ff7f 0%, #00b3cc 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            pt:11}}>
                            ⋆꩜｡ </Typography>

                    </Grid>
                        
                    <Typography gutterBottom variant="p" color="primary"
                    sx={{
                        fontSize:15,mt:50, ml:'10%' }}>
                            Making patterns out of chaos (without a crystal ball)</Typography>
                </Grid>
                </Grow>
                 
                <Grid item xs={tam} alignItems="center"
                    justifyCon5tent="center">
                </Grid>  

                <Fade direction="left" in={true} timeout={6000} mountOnEnter unmountOnExit>
                    <Grid item xs={tam} sx={{alignItems:"center",
                        justifyContent:"center"}}>  
                        <Button variant="outlined" size="medium" color="secondary"
                        sx={{fontFamily: 'Questrial',
                        borderColor: 'rgb(20, 213, 200)', ml:'30%', mt:2}}
                        onClick={redirect}>
                            See Projects
                        </Button>                      
                    </Grid>
                </Fade>     

           </Grid>

           <video z-index={1} src={bgvid} autoPlay loop muted/>

        </Box>
    )

    function getWindowSize() {
        const {innerWidth, innerHeight} = window;
        return {innerWidth, innerHeight};
      }

};